import { Link } from "react-router-dom";
import { useTexts } from "@/lib/layout";

export const MostRead = ({ items = [] }) => {
  const t = useTexts("layout");
  return (
  <aside data-testid="most-read">
    <div className="border-t-2 border-foreground pt-3 mb-2">
      <h2 className="font-display font-black text-2xl tracking-tight">{t.most_read_title}</h2>
    </div>
    <ol>
      {items.map((a, i) => (
        <li key={a.id} className="group border-b border-border last:border-0">
          <Link to={`/noticia/${a.slug}`} className="flex gap-4 py-4" data-testid={`most-read-item-${i}`}>
            <span className="font-display font-black text-4xl leading-none text-primary/80 w-11 shrink-0 tabular-nums">{String(i + 1).padStart(2, "0")}</span>
            <span className="font-display font-semibold text-[1.08rem] leading-snug transition-colors group-hover:text-primary">{a.title}</span>
          </Link>
        </li>
      ))}
    </ol>
  </aside>
  );
};
